import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';

import DashboardLayout from '../../components/dashboard/Dashboard';
import EditProfile from '../../components/dashboard/pages/EditProfile';
import Content from '../../components/dashboard/pages/Content';
import Consultant from '../../components/dashboard/pages/Consultation';
import OrderHistory from '../../components/dashboard/pages/OrderHistory';
import Affiliate from '../../components/dashboard/pages/Affiliate';
import Community from '../../components/dashboard/pages/Community';
import Course from '../../components/dashboard/pages/Courses';
import Audit from './../../components/dashboard/pages/Audit';


const Dashboard = () => {
  return (
    <>
      <SEO title="Dashboard" />
      <main>
        <HeaderOne btnStyle="btn-small" HeaderSTyle="" />
        <div className="rwt-advance-tab-area">
          <DashboardLayout>
            <Switch>
              <Route path="/dashboard/profile" component={EditProfile} />
              <Route path="/dashboard/courses" component={Course} />
              <Route path="/dashboard/content" component={Content} />
              <Route path="/dashboard/community" component={Community} />
              <Route path="/dashboard/consultent" component={Consultant} />
              <Route path="/dashboard/affiliate" component={Affiliate} />
              <Route path="/dashboard/orders" component={OrderHistory} />
              <Route path="/dashboard/audit" component={Audit} />
              
              {/* Add other routes here */}
            </Switch>
          </DashboardLayout>
        </div>
        <FooterOne />
        <Copyright />
      </main>
    </>
  );
};

export default Dashboard;
